<template>
    <div class="bulma">
        <div class="modal"
             v-if="show"
             :class="{ 'is-active': show }"
        >

            <div class="modal-background" v-on:click="hideAndClear"></div>
            <div class="modal-card">

                <header class="modal-card-head">
                    <p class="modal-card-title">
                        {{ title }}
                    </p>
                    <button
                        class="delete"
                        aria-label="close"
                        @click="hideAndClear"
                    ></button>
                </header>

                <section class="modal-card-body">
                    <div class="content">
                        <p>
                            {{ message }}
                        </p>

                    </div>
                </section>

                <footer class="modal-card-foot">
                    <button
                        v-if="isButtonShown"
                        class="button is-info"
                        v-on:click.prevent="deleteDocument"
                    >
                        {{ trans.delete_document_confirm_button }}
                    </button>

                    <button class="button" v-on:click="hideAndClear">
                        {{ cancelButtonText }}
                    </button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';

export default {
    name: "DocumentDeletionConfirmationModal",
    props: {
        trans: Object,
    },
    data() {
        return {
            isDocumentBlocked: false,
            isUserCanInterrupt: false,
            hash: null,
            documentEditingMessage: '',
        }
    },
    computed: {
        ...mapState('documentEditSession',
            {
                show: 'isDocumentDeletionConfirmationModalShown',
            }),
        ...mapGetters('documentEditSession',
            [
                'documentNode',
            ]
        ),
        title() {
            return trans.msg.deletion;
        },
        cancelButtonText() {
            return this.isButtonShown ? this.trans.cancel_button : this.trans.button_close;
        },
        message() {
            let nodeType = this.documentNode.is(kbSelector.section) ? 'section' : 'document',
                modalMsg = eval(`trans.msg.confirm_${nodeType}_delete`);

            if (this.isDocumentBlocked) {
                let modalIntro = this.documentEditingMessage;
                modalMsg = this.trans.delete_document_no_authority

                if (this.isUserCanInterrupt) {
                    modalMsg = this.trans.delete_document_notification;
                }

                modalMsg = `${modalIntro} ${modalMsg}`;
            }

            return modalMsg;
        },
        isButtonShown() {
            return !this.isDocumentBlocked || this.isUserCanInterrupt;
        },
    },
    methods: {
        ...mapActions('documentEditSession',
            {
                hideModal: 'hideDocumentDeletionConfirmationModal',
            }
        ),
        hideAndClear() {
            this.hideModal();
            this.clear();
        },
        /**
         * Функция для очищения параметров
         */
        clear() {
            this.isDocumentBlocked = false;
            this.isUserCanInterrupt = false;
            this.hash = null;
            this.documentEditingMessage = '';
        },
        /**
         * Функция вызывающая запрос на удаление документа
         */
        deleteDocument() {
            this.hash = this.documentNode.data('id');

            Utils.preloader(true);

            this.interruptWrapper(() => {
                this.deleteRequest()

                    .finally(() => {
                        Utils.preloader(false);
                    });
            });

        },
        /**
         * Функция обертка удаления документа с перехватом сессии
         * @param callback
         */
        interruptWrapper(callback) {
            if (this.isDocumentBlocked && this.isUserCanInterrupt) {
                let sessionInterruptUrl = Utils.replaceWildcards(
                    actions.session.start,
                    { document_hash: this.hash }
                );

                axios.post(sessionInterruptUrl, {interrupt: true})
                    .then(response => {
                        if (typeof callback === 'function') {
                            callback();
                        }
                    });
            }

            if (typeof callback === 'function') {
                callback();
            }
        },
        /**
         * Функция запроса на удаление документа
         * @return {Promise<void>}
         */
        deleteRequest() {
            let deleteDocumentUrl = `${actions.delete}/${this.hash}`;

            return axios.delete(deleteDocumentUrl)
                .then(response => {
                    sendGAEvent('Удаление документа');

                    window.deleteDocumentConfirmClick({'nodeId': this.hash});
                    this.hideAndClear();
                })
                .catch(error => {
                    if (error.response.status == 510) {
                        this.documentEditingMessage = error.response.data.message;

                        if (error.response.headers.mode == 'interrupt_request') {
                            this.isUserCanInterrupt = true;
                        }

                        this.isDocumentBlocked = true;
                    }
                });
        },
    }
}
</script>
